import {Box} from '@mantine/core';
import type {FC} from 'react';
import {cn} from '../../../lib/classname';
import {CommonLink} from '../../../shared/components/CommonLink';

type Props = {
  isRuleConfirm?: boolean;
};

const TEXT_CLASSNAME = 'leading text-black-1 text-base mb-8';
const SECTION_TITLE_CLASSNAME =
  'bg-background-1 text-md leading text-black-1 mb-12 py-4 px-8 font-bold';
const HIGHLIGHT_TEXT_CLASSNAME = 'bg-sub-2';

export const TermsContainer: FC<Props> = ({isRuleConfirm = false}) => {
  const highlightsLatestRevision = isRuleConfirm;

  return (
    <>
      <Box className="bg-white px-8 py-16 pc:px-32">
        {isRuleConfirm && (
          <div className="mb-32">
            <p className={`${TEXT_CLASSNAME}`}>
              <span className={`${HIGHLIGHT_TEXT_CLASSNAME}`}>
                ※変更箇所をハイライトしています
              </span>
            </p>
          </div>
        )}

        <div className="mb-16">
          <p className={`${TEXT_CLASSNAME}`}>
            「外資就活ドットコム」を運営する株式会社ハウテレビジョン（以下「弊社」といいます）は、外資就活ドットコム会員規約（以下「本規約」といいます）を、以下の通り定めます。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>
            第1条（外資就活ドットコム）
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            「外資就活ドットコム」とは、弊社が提供するインターネット上のコミュニティおよび就職情報サービス総合サイト（https://gaishishukatsu.com/）および当該サイトに付随するサブサイト、ならびにメール、スカウト配信その他の就職支援サービス、会員を対象とした各種情報提供サービスの総称をいいます。
          </p>
        </div>
        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>第2条（会員）</p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            本規約において「会員」とは、弊社の指定する手続きに基づき、本規約を承諾のうえ弊社所定の方法にて外資就活ドットコムの利用を申込み、弊社がこれを承認した者とします。当該会員登録および承認後、会員は外資就活ドットコムにおける会員向けサービスを利用できるものとします。ただし、弊社は、会員向けサービスの⼀部について、弊社の指定する⽅法による在籍の確認その他の確認が完了するまでの間、その利⽤を制限することができるものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2.
            会員は外資就活ドットコムに会員登録をした時点で、本規約の内容をすべて承諾したものとみなされます。不承諾の意思表示は、外資就活ドットコムの会員登録を行わないことまたは抹消することをもってのみ認められるものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            3.
            弊社が会員として承認することを不適切と判断した場合、入会を認めない場合があります。また承認後であっても第4条に従い承認の取り消しを行う場合があります。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            4.
            会員が登録した個人情報のうちメールアドレスに誤りがあったために第三者からクレームまたは削除依頼があった場合、会員は、弊社が事前の通知なしに当該メールアドレスを削除することを承諾するものとします｡
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            5.
            会員が会員登録の抹消を行わない場合または抹消を希望しない場合であっても、会員登録後の半年間に外資就活ドットコムに1度もログインしなかった場合、外資就活ドットコムのデータベースメンテナンスの際に会員登録が抹消されることがあります。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            6.
            弊社は会員への事前の通知なしに、外資就活ドットコムの会員サービスの変更または1週間に満たない一時的な中断を行うことがあります。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            7.
            弊社は1ヶ月の予告期間をもって会員に通知の上、外資就活ドットコム全体の提供を1週間以上中期的に中断または終了することができます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            8. 会員は、18歳以上の者に限るものとします。弊社は、会員が
            18歳未満であることが判明した場合、第4条に従い、会員への加⼊の承認の取り消しおよび会員登録の取り消しその他の措置をとることができるものとします。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>
            第3条（外資就活ネクストとの同時登録）
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            会員は、外資就活ドットコムに会員登録をした時点または本規約を承諾した時点で、弊社が提供するインターネット上のサイト（https://next.gaishishukatsu.com/）及び当該サイトに付随するサブサイト、並びにメール配信その他のサービス（以下、併せて「外資就活ネクスト」といいます）に関する規約（https://next.gaishishukatsu.com/terms）および外資就活ネクストに関する個人情報保護方針（https://next.gaishishukatsu.com/privacy）の内容をすべて承諾したものとみなされ、外資就活ドットコムと同じメールアドレスで外資就活ネクストに同時登録され、外資就活ネクストの会員向けサービスも利用できるものとします。
            なお、外資就活ネクストの会員向けサービスを利用するには、事前に外資就活ネクスト用のパスワードを設定する必要があります。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2.
            前項に定める規約、個人情報保護方針、同時登録への不承諾の意思表示は、外資就活ドットコムの会員登録を行わないことまたは当社が別途定める方法で外資就活ネクストの会員登録を抹消することをもってのみ認められるものとします。なお、外資就活ドットコムの会員登録を抹消しても、外資就活ネクストの会員登録は自動的には抹消されませんのでご留意ください。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>
            第4条（会員登録の取り消し）
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            弊社は、会員への加入を承認した場合でも、以下の項目に該当すると判断した場合は、事前通告なく会員への加入の承認の取り消しおよび会員登録の取り消しを行うことができ、当該会員に対して、外資就活ドットコムの全部あるいは一部の一時的・完全なサービスの利用停止の措置をとることができます。なお、弊社は、本措置とあわせて、外資就活ネクストのアカウントの削除を行うことができます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            申込者が本規約に基づく義務の履行を怠り、またはそのおそれのある場合。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2.
            弊社の運営を妨げ、もしくは信頼を毀損し、またはそれらのおそれがある場合。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            3.
            弊社のサービスを受ける際の登録事項が、故意・過失の有無に関わらず、虚偽・不十分・不正確であった場合。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>
            第5条（会員の禁止事項）
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            弊社が提供するサービスでは、下記の行為は禁止致します。これに違反した場合、弊社は第4条の措置またはそれに準じた措置を講ずることができるものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            他者の権利を侵害する行為（ストーカー、誹謗中傷等全てを含みます）。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>2. 他者の名誉を毀損する行為。</p>
          <p className={`${TEXT_CLASSNAME}`}>
            3.
            他者の個人情報や他者に属する著作権を侵害する表現を、当該人物の許可なく他の会員や第三者に送付・伝達、外資就活ドットコムを含むすべての掲示板などへの書き込みをする行為。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            4. 政治活動や宗教活動、またはそれらにつながる行為。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            5. 自らの身分や出所を偽る、あるいは不明にする行為。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            6. 営利を目的として行う一切の行為。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            7. 公序良俗に反する行為、犯罪行為またはそれらに関連する全ての行為。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            8. 法律、法令違反またはそれらに関連する全ての行為。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>9. サービスの目的に反する行為。</p>
          <p className={`${TEXT_CLASSNAME}`}>
            10.
            企業からの問い合わせまたはスカウト等の連絡に対し第三者に返答・対応させる行為。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            11.
            弊社サービス（AI選考対策機能その他AIを利用した機能を含みます。以下同じ。）の利用にあたり、要配慮個人情報（個人情報保護法第2条第3項に定めるものをいう）、第三者の個人情報、第三者の機密情報その他第三者の権利を侵害する情報を入力する行為。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            12.
            AIを利用した機能の正常な動作を妨げる行為（プロンプトインジェクションを目的とした入力、サービスの提供目的に反する不正な指示の入力、その他これらに類する行為を含みます）。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>第6条（会員の義務）</p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            会員は、弊社が提供するサービスの利用にあたり、弊社に登録しているメールアドレスおよびパスワードを使用するものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2.
            会員は、メールアドレスおよびパスワードの使用および管理について自ら責任を持つものとします。会員は、自己のメールアドレスおよびパスワードによりなされた、弊社が提供するサービスにかかる一切の行為およびその結果について当該行為を会員自身が行ったか否かまたは会員自身の過失の有無を問わず、自らその責任を負うものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            3.
            会員は、メールアドレスおよびパスワードの盗難もしくは失念があった場合、またはメールアドレスおよびパスワードが第三者に使用されていることが判明した場合、直ちに弊社にその旨を届け出ると共に、弊社からの指示に従うものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            4.
            会員が、第三者のメールアドレスおよびパスワードを不正に利用したことにより、当該第三者または弊社に損害を与えた場合、会員は当該不正使用によって生じた損害を当該第三者または弊社に賠償するものとします。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>
            第7条（登録情報の扱い）
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            1. 弊社は、会員の個人情報を、第8条にて定める通りに取り扱います。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2.
            入会の際に会員が申告する登録情報のすべての項目に関して虚偽の申告は一切認めないものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            3.
            登録情報に変更が生じた場合、会員は速やかに所定の変更手続きを行うものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            4.
            会員は、外資就活ドットコムの利用上発生した弊社、会員同士または第三者との間の苦情、クレーム、訴訟について、弊社が要求する事項（文章、口頭による交渉を含むがこれに限定されない）をすべて弊社に対して開示するものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            5.
            会員が本規約に同意する場合、弊社は電子メールを随時配信し、その他の「外資就活ドットコム」外での広告・通知を行います。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            6.
            会員に対して弊社より各種のアンケート調査についてご協力をお願いすることがあります。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            7.
            会員が本規約に同意する場合、当社は会員に対して、企業からの委託による企業個別の就職案内、その他の就職活動に役立つ情報や社会人の準備、社会人のキャリアアップに役立つ無料の情報や各種の学校、イベント情報など（外資就活ネクストに関連するものを含みますがそれらに限られません）のご案内を電子メール、ポップアップ通知などの手段により提供できるものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            8.
            弊社は、法令の規定に従い、登録情報をもとに、個人を特定できないよう加工した統計データを作成することがあります。当該統計データについては、弊社はこれを法令の規定に従い自由に利用（第三者への提供を含みます）できるものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            9. 会員が本規約に同意する場合、弊社は、登録情報（氏名、連絡先
            <span
              className={cn({
                [HIGHLIGHT_TEXT_CLASSNAME]: highlightsLatestRevision,
              })}
            >
              、住所
            </span>
            を除きます。）をもとに企業が会員に対してスカウトを送信することを許可し、会員が受信したスカウトを承諾した場合には、企業と会員間でメッセージのやり取りが可能となるチャット機能（以下「本チャット機能」といいます）を提供します。
          </p>
          <p
            className={cn(TEXT_CLASSNAME, {
              [HIGHLIGHT_TEXT_CLASSNAME]: highlightsLatestRevision,
            })}
          >
            会員が受信したスカウトを承諾した場合、弊社は、当該承諾をもって、氏名、ふりがな、連絡先（メールアドレス及び電話番号）その他の登録情報を、当該スカウトを送信した企業（当該企業がその採用活動を第三者に委託している場合には、当該委託先を含み、また、当該企業がその採用活動において応募者情報を管理するシステム（ATS）を利用している場合には、当該提供事業者を含みます。以下、本項及び次条において同じ。）に対して提供します。当該企業は、提供を受けた当該情報を、当該企業の管理の下、採用・選考業務の目的で利用し、ATS等のシステム上で管理する場合があります。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            なお、会員が受信したスカウトを承諾しない限り、氏名、連絡先が企業に開示されることはありません。
            <span
              className={cn({
                [HIGHLIGHT_TEXT_CLASSNAME]: highlightsLatestRevision,
              })}
            >
              住所については、スカウトの承諾の有無にかかわらず、企業に提供されることはありません。
            </span>
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            10.
            会員が第三者のサービスにかかるアカウント情報、個人のサイト、ブログ等のURL（以下、併せて「アカウント情報等」といいます）を登録した場合、弊社は、インターネット上で開示されまたは第三者のサービス上で開示されている当該アカウント情報等に紐づく第三者サービスのスコア、ステータス等（以下「スコア等」といいます）の取得を行う場合があります。また、弊社は、アカウント情報等およびスコア等を企業に開示し、企業が会員に対してスカウトを送信することを許可します。なお、会員が受信したスカウトを承諾しない限り、氏名、連絡先が企業に開示されることはありません。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            11.
            会員が本規約に同意する場合、外資就活ドットコムと同時登録された外資就活ネクストのアカウントに対して、会員の登録情報（氏名、メールアドレス、所属大学、内定先等を含みますがこれらに限られません。）が連携されます。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>第8条（個人情報）</p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            「個人情報」とは、会員個人に関する情報であって、当該情報を構成する氏名、メールアドレス、学校名その他の記述により当該会員を識別できるものをいいます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            また、その情報のみで識別できない場合でも、他の情報と容易に照合することができ、結果的に会員個人を識別できるもの（アプリおよび各種のインターネット閲覧ソフト（ブラウザ）での外資就活ドットコムへのログイン情報、閲覧履歴、募集・イベント等へのエントリーその他サービス利用履歴（以下、あわせて「利用履歴等」といいます。）、会員が弊社に提供した選考体験記、インタビューへの回答
            <span>
              、会員が外資就活ドットコムに入力した求人企業の選考等へのエントリー状況（イベントタイトル、実施場所・日程等を含む）、進捗状況、関連するToDo・メモ、選考等の結果
            </span>
            など）も個人情報に含まれます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2.
            会員から提供された会員の個人情報は、本規約に定めるほか、弊社の個人情報保護方針（外資就活ドットコムの利用に関するプライバシーポリシーおよび外資就活ネクストの個人情報保護方針を含みます。以下も同様です。）に従って管理・利用されます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            3. 応募先企業など
            <span
              className={cn({
                [HIGHLIGHT_TEXT_CLASSNAME]: highlightsLatestRevision,
              })}
            >
              （スカウトを送信した企業を含み、当該企業がその採用活動を第三者に委託している場合には、当該委託先を含み、また、当該企業がその採用活動において応募者情報を管理するシステム（ATS）を利用している場合には、当該提供事業者を含みます。以下、当該委託先及び当該提供事業者を総称して「委託先等」といいます。）
            </span>
            に提供された会員の個人情報は、それぞれの企業の管理の下に、採用・選考業務のために利用されます。
            <span
              className={cn({
                [HIGHLIGHT_TEXT_CLASSNAME]: highlightsLatestRevision,
              })}
            >
              当該委託先等は、当該企業の指示に基づき、当該企業のためにのみ会員の個人情報を取り扱います。
            </span>
            企業が管理する個人情報の取り扱いに関しては、各企業に直接お問い合わせください。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            4.
            弊社は、個人情報の管理には万全の体制で臨みます。弊社は、弊社の個人情報保護方針に定める場合を除き、会員の承認なしに第三者に対して個人情報を開示しないものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            5.
            以下の各号の場合においては、個人情報の提供を受ける者は、本条の規定の適用に関して第三者には該当しないものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            (1)
            弊社がサービス提供のための範囲内において、個人情報の整理、分析、保管、デジタル化、発送、電子メールの送付、ポップアップ通知
            、求人・イベント情報等の広告の配信（外資就活ドットコム以外のWEBサイト、SNSなどでの配信を含みます。）
            などの個人情報取扱い業務の全部または一部を委託する場合。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            a.
            弊社は、利用履歴等の収集、分析、会員への電子メールの送付、ポップアップ通知などに関して、Appier
            Japan株式会社が提供するマーケティングオートメーションツール「AIQUA」を利用しており、Appier
            Japan株式会社に対して個人情報取扱い業務の一部を委託しています。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            AIQUA公式サイト：
            <br />
            <CommonLink
              className="text-link-1"
              href="https://www.appier.com/ja-jp/products/aiqua?hsLang=ja-jp"
            >
              https://www.appier.com/ja-jp/products/aiqua?hsLang=ja-jp
            </CommonLink>
            <br />
            Appier Japan株式会社プライバシーポリシー：
            <br />
            <CommonLink
              className="text-link-1"
              href="https://www.appier.com/ja-jp/about/privacy-policy"
            >
              https://www.appier.com/ja-jp/about/privacy-policy
            </CommonLink>
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            b.弊社は、選考体験記、インタビューへの回答その他のサービスに関連して会員が弊社に提供した内容、サービス上で会員が掲示した内容等の収集、分析、会員への提供
            <span>
              、ならびにAI選考対策機能における音声入力（音声認識）および音声出力（音声合成）の処理
            </span>
            に関して、OpenAI.LLC（以下「OpenAI」）が提供する対話型AIチャットサービス「ChatGPT」
            <span>
              、音声認識サービス「Whisper」および音声合成サービス「gpt-4o-mini-tts」（その他、これらに類するOpenAIが提供するサービスを含みます。）
            </span>
            を利用しており、OpenAI.LLCに対して個人情報取扱い業務の一部を委託しています。
          </p>

          <p className={`${TEXT_CLASSNAME}`}>
            ChatGPT公式サイト：
            <br />
            <CommonLink
              className="text-link-1"
              href="https://openai.com/chatgpt/"
            >
              https://openai.com/chatgpt/
            </CommonLink>
            <br />
            <span>
              Whisper/gpt-4o-mini-tts 公式ドキュメント:
              <br />
              <CommonLink
                className="text-link-1"
                href="https://platform.openai.com/docs/"
              >
                https://platform.openai.com/docs/
              </CommonLink>
            </span>
            <br />
            OpenAIプライバシーポリシー
            <br />
            <CommonLink
              className="text-link-1"
              href="https://openai.com/policies/privacy-policy/"
            >
              https://openai.com/policies/privacy-policy/
            </CommonLink>
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            c.弊社は、求人・イベント情報等の各種広告の配信（外資就活ドットコム以外のWEBサイト、SNSなどでの配信を含みます。）に関して、株式会社イオレが提供する広告配信システム「pinpoint」を利用しており、株式会社イオレに対して、会員から提供されたメールアドレスをハッシュ化したデータ、大学名、学部名、学部の分類（文理）、卒業予定年度、志望業界、サークル名、外資就活ドットコムの利用履歴等、Cookie、広告識別子（Identification
            For Advertisers、Google advertising
            ID）を含む個人情報取扱い業務の一部を委託しています。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            pinpoint公式サイト：
            <br />
            <CommonLink
              className="text-link-1"
              href="https://www.pinpointdmp.com/"
            >
              https://www.pinpointdmp.com/
            </CommonLink>
            <br />
            株式会社イオレ 個人情報及び特定個人情報保護方針
            <br />
            <CommonLink
              className="text-link-1"
              href="https://www.eole.co.jp/privacypolicy.html"
            >
              https://www.eole.co.jp/privacypolicy.html
            </CommonLink>
          </p>
          <div>
            <p className={`${TEXT_CLASSNAME}`}>
              d.
              弊社は、AI選考対策機能における面接質問の生成、面接対話、回答内容の評価その他のAI
              処理に関して、Google LLC（以下「Google」）が提供する生成
              AIサービス「Gemini API」を利用しており、Google
              LLCに対して個人情報取扱い業務の一部を委託しています。
            </p>
            <p className={`${TEXT_CLASSNAME}`}>
              Gemini API 公式サイト：
              <br />
              <CommonLink
                className="text-link-1"
                href="https://ai.google.dev/gemini-api"
              >
                https://ai.google.dev/gemini-api
              </CommonLink>
              <br />
              Gemini API 利用規約：
              <br />
              <CommonLink
                className="text-link-1"
                href="https://ai.google.dev/gemini-api/terms?hl=ja"
              >
                https://ai.google.dev/gemini-api/terms?hl=ja
              </CommonLink>
              <br />
              Google プライバシーポリシー：
              <br />
              <CommonLink
                className="text-link-1"
                href="https://policies.google.com/privacy"
              >
                https://policies.google.com/privacy
              </CommonLink>
            </p>
          </div>

          <p className={`${TEXT_CLASSNAME}`}>
            (2)
            弊社の合併その他の事由による事業の承継に伴って個人情報が提供される場合
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>第9 条（権利の帰属）</p>
          <p className={`${TEXT_CLASSNAME}`}>
            弊社が外資就活ドットコムを通じて提供するサービス上で、会員が掲示した内容および選考体験記、インタビューへの回答その他の会員が弊社に提供した内容
            により知的所有権（著作権・意匠権・特許権・実用新案権・商標権・ノウハウ等を含むがこれに限られない）が発生する場合、当該権利はすべて弊社に帰属するものとします。また、弊社が外資就活ドットコムを通じて行う募集に対して応募した会員の作品、コンテンツについても同様とします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            なお、外資就活ドットコム内の情報が、新聞・雑誌などに掲載され、あるいは書籍として出版されることもありますのであらかじめご了承ください。但し、弊社は会員の個人情報を会員の承諾なしに公開することはありません。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>第10 条（情報の利用）</p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            会員は、弊社が承認した場合（当該情報に関して権利を持つ第三者がいる場合には、弊社を通じ当該第三者の承認を取得することを含む。）を除き、外資就活ドットコムを通じて入手したいかなる情報も複製、販売、出版、公開その他いかなる方法においても会員の個人としての私的利用以外の利用をすることはできず、また他の会員または第三者をして同様の行為をさせてはなりません。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2. 会員は、営利の目的で外資就活ドットコムを利用してはなりません。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            3.
            この禁止事項を行った場合も、第4条の措置を講ずることができるものとします。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>第11条（弊社の免責等）</p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            弊社は外資就活ドットコムの利用により発生した会員または他の第三者が被った損害すべてに対し、いかなる責任も負わないものとし、一切の損害賠償をする義務はないものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2.
            弊社は、外資就活ドットコムおよびその周辺サービスの遅滞なき運用に努力しますが、その運用を何ら保証するものではなく、運用の中断・停止または廃止に基づく損害賠償義務を免責されます。また、やむをえぬ事態により、弊社は、会員の承諾なく、提供サ－ビスの内容の全部あるいは一部を変更・中断もしくは停止あるいは廃止する（改廃を含む）ことができます。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            3.
            外資就活ドットコムにおいて提供される情報（企業の採用情報、広告その他第三者により提供される情報）はこの第三者の責任で提供されるものであり、これらの提供情報の内容に関して弊社は一切の保証を行わないことを会員は了承の上、自己の責任において利用するものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            4.
            弊社は会員から提供された原稿・画像・音声などの情報等を編集・再構成できる権利を持つものとし、会員はこれに対し著作者人格権を行使せず、また、何ら異議を申し立てないものとします。ただし、弊社はかかる編集等の義務は一切負わないものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            5.
            弊社が会員に対して提供する情報・サービスについては、弊社は、これの完全性、正確性、有用性および合目的性に対し、弊社はその調査義務を一切負わないものとし、また、一切の保証をおこなわないものとします。また提供された情報に起因する損害（身体的、精神的、財産的損害を含む）が会員に発生した場合でも、弊社は一切の責任を負わないものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            6.
            弊社は、掲示板への投稿およびメールの交換を含む会員同士の情報交換ならびに本チャット機能を用いるものを含む企業と会員との間の情報交換について、
            通信の秘密にあたる情報に関して通信の秘密を侵害せず、安全に管理するように努めます。ただし、①本チャット機能を含む弊社のサービスに関する不正利用の防止、安全な運営、品質向上および新たなサービスの開発等正当な業務行為として必要である場合、②法令の定めに基づく強制力のある処分もしくは裁判所の命令がなされた場合、または③会員または第三者の生命、身体、財産または名誉・プライバシー等の重要な権利保護のために必要である場合には、弊社は、情報交換にかかる情報（通信の秘密にあたる情報を含むものとします。）を、当該情報交換の当事者の同意を得ずに、閲覧、調査、保全、削除等を行う権利を持ちますが、閲覧、調査等を実施する義務を負わないものとし、当該閲覧、調査等を行ったことまたは行わなかったことに対して、一切の責任を負わないものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            7.
            弊社は、会員によるメモ（非公開のメモおよび下書き中のメモを含みます。以下も同様です。）の内容を閲覧・調査することはありません。ただし、メモの利用、メモにかかるシステム等に関して異常が検知されるなどの合理的な理由がある場合には、弊社は、不正なデータの有無等を確認するため、メモの利用状況、内容等を閲覧・調査することがあります。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            8.
            弊社は会員同士、会員と第三者、あるいは第三者同士のトラブルに対して、一切の責任を負わないものとします。万一トラブルが発生した場合、これを弊社を含まない当事者同士で解決するものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            9.
            弊社の提供するサービスに関して紛争が生じ、弊社が会員または第三者からクレームを受け、裁判所において損害賠償その他の責任を認定され、その支払いに応じた場合には、弊社は、当該トラブルの原因を作出した会員に対し、当該紛争にかかる一切の費用（賠償金、訴訟費用および弁護士費用を含む）を請求できるものとします。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>
            第12 条（無断転載、再配布の禁止）
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            外資就活ドットコムは、弊社の運営するサイト名・サービス名であり、外資就活ドットコム上の記事・写真・イラストの無断転載、再配布を禁じます。
          </p>
        </div>

        <div className="mb-16">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>第13条（管轄裁判所等）</p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            本規約に定めのない事項または本規約の解釈に疑義がある場合、信義に則り誠実にこれを解決するものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2. 本規約の準拠法は、日本法とします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            3.
            会員と弊社の間で訴訟の必要が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            4.
            第11条第1項の規定が裁判所によって無効と判断され、会員が弊社に対し損害賠償請求権等の何らかの請求権を有する場合、会員は、その権利につき、その発生原因が生じた日から1年以内に権利行使をしなければ、当該権利は失効するものとします。
          </p>
        </div>

        <div className="mb-36">
          <p className={`${SECTION_TITLE_CLASSNAME}`}>第14条（規約の変更）</p>
          <p className={`${TEXT_CLASSNAME}`}>
            1.
            弊社は、会員の了承を得ることなく、この会員規約を変更することがあります。また改訂された本規約は、改訂以前、以後に会員登録したかに関わらずすべての会員に対して適用されるものとします。
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2.
            変更後の会員規約は、弊社が別途定める場合を除いて、オンライン上に表示した時点より効力を生じるものとします。
          </p>
        </div>

        <div>
          <p className={`${TEXT_CLASSNAME}`}>附則</p>
          <p className={`${TEXT_CLASSNAME}`}>
            2010年10月1日作成/ 2010年10月1日適用
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2016年3月23日改訂/ 2016年3月23日適用
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2018年12月6日改訂/ 2018年12月6日適用
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2019年7月30日改訂/ 2019年7月30日適用
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2020年7月21日改訂/ 2020年7月21日適用
          </p>
          <p className={`${TEXT_CLASSNAME}`}>
            2021年5月19日改訂/ 2021年5月19日適用
          </p>
          <p className={`${TEXT_CLASSNAME} mb-0`}>
            2023年3月14日改訂/ 2023年3月15日適用
          </p>
          <p className={`${TEXT_CLASSNAME} mb-0`}>
            2025年1月20日改訂/ 2025年1月20日適用
          </p>
          <p className={`${TEXT_CLASSNAME} mb-0`}>
            2025年04月22日改訂/ 2025年4月22日適用
          </p>
          <p className={`${TEXT_CLASSNAME} mb-0`}>
            2026年01月16日改訂/ 2026年1月16日適用
          </p>
          <p className={`${TEXT_CLASSNAME} mb-0`}>
            2026年04月30日改訂/ 2026年4月30日適用
          </p>
          <p className={`${TEXT_CLASSNAME} mb-0`}>
            2026年08⽉04⽇改訂/ 2026年8⽉04⽇適⽤
          </p>
          <p className={`${TEXT_CLASSNAME} mb-0`}>
            <span
              className={cn({
                [HIGHLIGHT_TEXT_CLASSNAME]: highlightsLatestRevision,
              })}
            >
              2026年09月28日改訂/ 2026年9月28日適用
            </span>
          </p>
        </div>
      </Box>
    </>
  );
};
